import { render, staticRenderFns } from "./HighlightStats.vue?vue&type=template&id=5db0701f&scoped=true&"
import script from "./HighlightStats.vue?vue&type=script&lang=js&"
export * from "./HighlightStats.vue?vue&type=script&lang=js&"
import style0 from "./HighlightStats.vue?vue&type=style&index=0&id=5db0701f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db0701f",
  null
  
)

export default component.exports